import React from 'react';
import { render, fireEvent } from '@testing-library/react';
import ThemeHelpBox from './theme_help_box';

describe('ThemeHelpBox', () => {
    beforeEach(() => {
        localStorage.removeItem('wk_theme_help_dismissed');
    });

    it('renders when not dismissed', () => {
        const { getByText } = render(<ThemeHelpBox />);
        expect(getByText(/Customize your slide design/i)).toBeTruthy();
    });

    it('hides when dismiss button clicked', () => {
        const { getByLabelText, queryByText } = render(<ThemeHelpBox />);
        fireEvent.click(getByLabelText('Dismiss'));
        expect(queryByText(/Customize your slide design/i)).toBeNull();
    });

    it('contains upload instruction text', () => {
        const { container } = render(<ThemeHelpBox />);
        expect(container.textContent).toMatch(/Upload a .protheme file/i);
    });

    it('hides when hasCustomTheme is true', () => {
        const { queryByText } = render(<ThemeHelpBox hasCustomTheme={true} />);
        expect(queryByText(/Customize your slide design/i)).toBeNull();
    });
});
